<template>
  <v-card>
    <v-form>
      <v-container grid-list-lg>
        <v-layout wrap>
          <v-flex xs12 class="flex-container-space-between vertical-center-container">
            <div class="headline">{{title}}</div>
          </v-flex>
          <input type="file" ref="fileUpload" style="display:none" @change="onFileChange" />
          <v-flex xs12>
            <v-text-field
              label="Select File"
              :color="primaryNeutral"
              prepend-icon="attach_file"
              readonly
              :value="typeof file == 'object' ? file.name : '' "
              v-model="file.name"
              @click="openFileDialog"
              :loading="loading"
            ></v-text-field>
          </v-flex>
          <!-- <v-flex xs12 v-if="route == 'docket'">
            <v-autocomplete
              label="* Billing Period"
              :color="primaryNeutral"
              prepend-icon="calendar_today"
              :items="openBillingPeriods"
              v-model="billingPeriod"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 v-if="$route.name == 'tipping'">
            <div
              class="body-2 grey--text"
            >File must not exceed 500 lines. If it is longer, split your file at a change of Vehicle, Date or External ref.</div>
          </v-flex> -->
          <v-flex>
            <v-expansion-panel popout>
              <v-expansion-panel-content v-model="panel" :disabled="!results">
                <div slot="header" class="font-weight-medium grey--text text--darken-2">Results</div>
                
                <v-card v-if="results">
                  <div class="ml-4 mr-4 mb-3 mt-2 text--lighten-2" v-if="results.totalValidDollars">
                    Total for 
                    {{ results.createdCount ? 'imported' : 'valid' }} lines: 
                    ${{ results.totalValidDollars.toFixed(4) }}
                  </div>
                  <v-list two-line dense>
                    <v-divider></v-divider>
                    <fancy-list-tile
                      v-if="!!results.createdCount"
                      icon="check_circle_outline"
                      color="green lighten-3"
                      title="Successfully Added!"
                      :subTitle="`${results.createdCount} were added!`"
                      noAvatar
                    ></fancy-list-tile>
                    

                    <div v-if="results.errorRecords.length < 10">
                      <v-list-group v-for="(errorRecord, i) of results.errorRecords" :key="i">
                        <v-list-tile two-line slot="activator">
                          <v-list-tile-action>
                            <!-- <v-icon
                              color="indigo lighten-3"
                              v-if="errorRecord.error.conflict"
                            >not_interested</v-icon> -->
                            <v-icon color="red lighten-3">error_outline</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title
                              class="body-2"
                            >{{ route == 'docket' ? errorRecord.message : `Line ${errorRecord.line+1}`}}</v-list-tile-title>
                            <v-list-tile-sub-title>{{errorRecord.conflict ? 'Duplicate!' : 'See Errors...'}}</v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <!-- AN ERROR REASON-->
                        <div
                          v-for="(error, i) in errorRecord.errors"
                          :key="i"
                          class="ml-4 mr-4 mb-3 mt-2 red--text text--lighten-2"
                        >Line: {{errorRecord.line+1}} - {{error}}</div>
                      </v-list-group>
                    </div>

                    <!-- ERRORS GREATER THAN 10 LINES -->
                    <div v-if="results.errorRecords.length >= 10">

                      <!-- ERRORS HEADER -->
                      <v-list-tile two-line>
                        <v-list-tile-action>
                          <v-icon color="red lighten-3">error_outline</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title class="body-2">{{`${results.failedCount} errors`}}</v-list-tile-title>
                          <v-list-tile-sub-title>{{`There were errors on ${results.failedCount} lines.`}}</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>

                      <!-- LIST OF ERRORS -->
                      <virtual-list :size="60" :remain="8">
                        <div v-for="(errorRecord, i) of results.errorRecords" :key="i">
                          <div
                            v-for="(error, i) in errorRecord.errors"
                            :key="i"
                            class="ml-4 mr-4 mb-3 mt-2 red--text text--lighten-2"
                          >Line: {{errorRecord.line+1}} - {{error}}</div>
                        </div>
                      </virtual-list>
                    </div>

                    <v-divider></v-divider>
                  </v-list>
                  <v-card-text>
                    <div class="body-2 grey--text flex-container-space-between">
                      <div>{{results.createdCount}} Added</div>
                      <div v-if="!!results.failedCount">{{results.failedCount}} Failed</div>
                    </div>
                    <div v-if="!!results.matchedCount" class="body-2 primary--text text--lighten-2">
                      <div>{{results.matchedCount}} Matched</div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat color="grey darken-1" @click="close()">Close</v-btn>
      <v-btn
        flat
        color="green"
        :disabled="!file"
        :loading="loading"
        @click="uploadFile"
      >
        <v-icon left>cloud_upload</v-icon>Upload
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ApprovedBillLineService from '@/services/requests/approvedBillLineService'
import Store from '@/store/computed/storeHelpers'
import virtualList from 'vue-virtual-scroll-list'
import BillingPeriods from '@/services/mixins/billingPeriods'

export default {
  mixins: [BillingPeriods],
  props: {
    title: String
  },
  data() {
    return {
      file: '',
      loading: false,
      results: null,
      panel: false
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    openFileDialog() {
      this.$refs.fileUpload.click()
    },
    onFileChange() {
      this.file = this.$refs.fileUpload.files[0]
    },
    uploadFile() {
      if (!this.file) {
        this.snack({ text: 'Please select a file', color: 'yellow' })
        return
      }
      this.panel = false
      this.loading = true
      let formData = new FormData()
      formData.append('file', this.file)
      this.uploadApprovedBillLines(formData)
    },
    uploadApprovedBillLines(formData) {
      ApprovedBillLineService.importApprovedBillLines(formData)
        .then(result => {
          this.handleSuccess(result)
          this.fetchApprovedBillLines = true
        })
        .catch(err => {
          this.snack({ text: err.response.data.message, color: 'red' })
          this.results = null
          this.loading = false
        })
    },
    handleSuccess(result) {
      var color = !!result.data.result.createdCount ? 'green' : 'yellow'
      this.snack({ text: result.data.message, color: color })
      this.results = result.data.result
      if (this.results.createdRecords) {
        for (const record of this.results.createdRecords.rows) {
          this.$store.commit('approvedBillLines/addToArrayState', {
            prop: 'approvedBillLines',
            value: record
          })
        }
      }
      this.panel = true
      this.loading = false
    },
    handleError(err) {
      console.log(err)
      this.snack({ text: err.response.data.message, color: 'red' })
      this.results = err.result
      this.loading = false
    }
  },
  computed: {
    approvedBillLines: Store.getSet({
      store: 'approvedBillLines',
      prop: 'approvedBillLines'
    }),
    fetchApprovedBillLines: Store.getSet({
      store: 'approvedBillLines',
      prop: 'fetchApprovedBillLines'
    }),
    route() {
      return this.$route.name
    },
    duplicates() {
      var duplicates = []
      if (!!this.results) {
        for (var errorRecord of this.results.errorRecords) {
          if (errorRecord.conflict) duplicates.push(errorRecord)
        }
        return duplicates
      } else {
        return duplicates
      }
    }
  },
  components: {
    virtualList
  }
}
</script>

<style>
</style>
